import { TAccount, TAccountType, TCountry, TCurrency } from "@/api/v1_0";
import * as Domain from "@/domain";
import { JSONSchema, validateData } from "@/validation";
import {
  Enum,
  Min,
  MinLength,
  NotNullable,
  Number,
  Optional,
  Required,
  Rules,
  Same,
  Uuid,
} from "@/validation/rules";
import { Color } from "./color";
import { Currency } from "./currency";
import { Icon } from "./icons";

export namespace Saving {
  export interface IInput extends Partial<TAccount> {
    uuid?: string;
    type: TAccountType;
    name?: string;
    currency: TCurrency;
    icon?: Icon.IIcon;
    color?: Color.ISchemaColor;
    balance?: number;
  }

  export interface IErrors {
    uuid?: string;
    type?: string;
    name?: string;
    currency?: string;
    icon?: string;
    color?: string;
    balance?: string;
  }

  export const create = (currency: TCurrency): IInput => ({
    currency,
    type: TAccountType.Saving,
  });

  const validationRules = (country: TCountry): JSONSchema<IInput> => ({
    type: "object",
    properties: {
      uuid: Rules(Optional(), Uuid()),
      type: Rules(Required(), Same(TAccountType.Saving)),
      name: Rules(Required(), NotNullable(), MinLength(1)),
      currency: Rules(Required(), Enum(Currency.currencies)),
      icon: Rules(
        Optional(),
        Enum([...Icon.icons, ...Domain.Icon.bankIcons(country)])
      ),
      color: Rules(Optional(), Enum(Color.colors)),
      balance: Rules(Optional(), Number(), Min(0)),
    },
  });

  export const validate = (input: IInput, country: TCountry) =>
    validateData<IInput, IErrors, TAccount>(input, validationRules(country));
}
